<template>
  <treeselect
    :value="value"
    :multiple="true"
    :options="options"
    v-bind="$attrs"
    @input="$emit('input', $event)"
  >
    <div class="d-grid gap-4 d-md-flex" slot="before-list">
      <CButton
        class="mx-2"
        size="sm"
        variant="outline"
        color="info"
        @click="selectAll"
        >Select All</CButton
      >
      <CButton size="sm" variant="outline" color="info" @click="deselectAll"
        >Deselect All</CButton
      >
    </div>
  </treeselect>
</template>

<script>
export default {
  name: 'SelectAllTreeselect',
  inheritAttrs: false,
  props: {
    value: {
      type: Array,
      default: null,
    },
    options: {
      type: Array,
      required: true,
    },
  },
  methods: {
    selectAll() {
      this.$emit(
        'input',
        this.options.map((value) => value.id)
      );
    },
    deselectAll() {
      this.$emit('input', []);
    },
  },
};
</script>
